/**
 * Funciones de validación para navigation guards
 * Extraídas para facilitar testing sin dependencias del store
 */

/**
 * Verifica si el usuario actual es un distribuidor avanzado
 * @param {Object} userData - Datos del usuario
 * @returns {boolean}
 */
export function isDistribuidorAvanzado(userData) {
	return !!(userData &&
		userData.distributor_code &&
		userData.available_features &&
		userData.available_features.feature_distribuidor_avanzado);
}

/**
 * Verifica si el usuario actual es un trabajador de distribuidor avanzado
 * @param {Object} userData - Datos del usuario
 * @returns {boolean}
 */
export function isTrabajadorDistribuidorAvanzado(userData) {
	return !!(userData &&
		userData.sender_docs_user_id &&
		userData.available_features &&
		userData.available_features.feature_trabajador_distribuidor_avanzado);
}

/**
 * Verifica si el usuario de sesión (loginas) es un distribuidor avanzado
 * @param {Object} userData - Datos del usuario
 * @returns {boolean}
 */
export function isSessionUserDistribuidorAvanzado(userData) {
	return !!(userData &&
		userData.session_user &&
		userData.session_user.is_distribuidor_avanzado);
}

/**
 * Verifica si el usuario de sesión (loginas) es un trabajador de distribuidor avanzado
 * @param {Object} userData - Datos del usuario
 * @returns {boolean}
 */
export function isSessionUserTrabajadorDistribuidorAvanzado(userData) {
	return !!(userData &&
		userData.session_user &&
		userData.session_user.is_trabajador_distribuidor_avanzado);
}

/**
 * Verifica si el usuario puede acceder a /debug_distribuidor
 * Casos permitidos:
 * 1. Usuario actual es distribuidor avanzado (distributor_code + feature_distribuidor_avanzado)
 * 2. Usuario actual es trabajador de distribuidor avanzado (sender_docs_user_id + feature_trabajador_distribuidor_avanzado)
 * 3. Usuario de sesión (loginas) es distribuidor avanzado
 * 4. Usuario de sesión (loginas) es trabajador de distribuidor avanzado
 * @param {Object} userData - Datos del usuario
 * @returns {boolean}
 */
export function canAccessDebugDistribuidor(userData) {
	return isDistribuidorAvanzado(userData) ||
		isTrabajadorDistribuidorAvanzado(userData) ||
		isSessionUserDistribuidorAvanzado(userData) ||
		isSessionUserTrabajadorDistribuidorAvanzado(userData);
}
